import BaseMapper from '../../BaseMapper';
import { store } from '../../../store';
import { LANGUAGES } from '../../../constants/defaultValues';

const SportEventMapper = (data, context) => {
    const reduxStore = store.getState();

    const { locale } = reduxStore.settings;

    data.categoryName = data.category.names[locale] || data.category.names[LANGUAGES.eng];
    data.countryCode = data.category.countryCode;
    data.currentSeasonId = data.season.currentSeasonId;
    data.leagueName = data.season.seasonName;
    data.seasonRefId = data.season.id;

    return data;
};

export default SportEventMapper;
